import * as React from "react"
import Seo from "@components/seo"
import Layout from "@layout"
import Header from "@layout/header/header-one"
import Footer from "@layout/footer/footer-one"
import PublicationBIArea from "@containers/publicationBI-area"
import Banner from "@components/banners/Ai";


const PublicationBIPage = ({pageContext, location }) => (
  <Layout location={location}>
    <Seo title="All Publications" />
    <Header />
    {<Banner
			pageContext={pageContext}
			location={location}
			title="Publications on Business Intelligence"
		/> }
    <main className="site-wrapper-reveal">
      <PublicationBIArea />
    </main>
    <Footer />
  </Layout>
)

export default PublicationBIPage
